import {
  createPushToken as _createPushToken,
  FirestoreCollections,
} from '@griply/services';
import { Locales } from '@griply/types';
import { doc, getFirestore, serverTimestamp, setDoc } from 'firebase/firestore';
import { version } from 'package.json';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { setPushNotificationTokenDate } from 'shared/services/local-storage';
import { ID } from 'shared/types/id';
import { isProductionEnvironment } from 'shared/utils/is-environment';

import { setPushNotificationToken } from './helpers';

export const createPushToken = async (
  uid: ID,
  token: string,
  locale: Locales = Locales.EnUS,
) => {
  if (!isProductionEnvironment) {
    // eslint-disable-next-line no-console -- dev only
    console.log('create push token - ', { token, uid });
  }
  if (!uid || !token) {
    return;
  }

  _createPushToken({
    userId: uid,
    token,
    type: 'desktop',
    platform: 'web', // todo: when electron is created, change this to electron
    version,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: locale,
    db: getFirestore(),
    doc,
    setDoc,
    serverTimestamp,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.CreatePushToken,
        error,
        docPath: `${FirestoreCollections.FcmTokens}/${token}`,
        uid,
      }),
  }).catch((error) =>
    logFirestoreWriteError({
      op: FirestoreWriteOp.CreatePushToken,
      error,
      docPath: `${FirestoreCollections.FcmTokens}/${token}`,
      uid,
    }),
  );

  setPushNotificationToken(uid, token);
  setPushNotificationTokenDate(uid, new Date());
};
